import { HTTP } from '@/utils';
import { AxiosResponse } from 'axios';

interface ResonantEdOAuthResponse {
  oauth_url: string;
  user_id: string;
  permissions: string[];
  area: string;
  iframe_options: {
    allow: string;
    sandbox: string;
    title: string;
  };
  available_urls?: string[];
}

interface ResonantEdScreener {
  id: string;
  name: string;
  status: string;
  [key: string]: unknown;
}

interface ResonantEdScreenersResponse {
  screeners: ResonantEdScreener[];
}

interface ResonantEdUser {
  id: string;
  email?: string;
  name?: string;
  [key: string]: unknown;
}

class ResonantEdService {
  static async getOAuthUrl(): Promise<ResonantEdOAuthResponse> {
    const response = await HTTP.get('/resonant-ed/oauth-url');
    return response.data;
  }

  static async getUserScreeners(): Promise<AxiosResponse<ResonantEdScreenersResponse>> {
    return HTTP.get('/resonant-ed/user-screeners');
  }

  static async validateUserId(
    userId: string,
  ): Promise<AxiosResponse<{ valid: boolean; user?: ResonantEdUser; message?: string }>> {
    return HTTP.post('/resonant-ed/validate-user', {
      user_id: userId,
    });
  }
}

export default ResonantEdService;
